module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlAlarm", "Alarm" ) ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="alarm-wrap"><span class="master-switch">'+
((__t=( i18n.tc( "MasterSwitch", "Master switch:" ) ))==null?'':__t)+
'</span><div data-input="main-alarm-strip" data-name="alarm-radio"><option data-value="ON">'+
((__t=( i18n.tc("ControlAlarm", "On") ))==null?'':__t)+
'</option><option data-value="OFF">'+
((__t=( i18n.tc("ControlAlarm", "Off")))==null?'':__t)+
'</option></div></div><hr class="line-button-deputy"><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div><h5>'+
((__t=( i18n.tc( "ControlAlarm", "General alarm:" ) ))==null?'':__t)+
'</h5><div data-input="general-alarm-strip" data-name="alarm-radio"><option data-value="ON">'+
((__t=( i18n.tc("ControlAlarm", "On") ))==null?'':__t)+
'</option><option data-value="OFF">'+
((__t=( i18n.tc("ControlAlarm", "Off")))==null?'':__t)+
'</option></div><label>'+
((__t=( i18n.tc( "ControlAlarm", "Follow main:" ) ))==null?'':__t)+
'</label><div data-input="general-alarm-follow-main-strip" data-name="alarm-radio"><option data-value="ON">'+
((__t=( i18n.tc("ControlAlarm", "On") ))==null?'':__t)+
'</option><option data-value="OFF">'+
((__t=( i18n.tc("ControlAlarm", "Off")))==null?'':__t)+
'</option></div><div><label for="alarm-message">Message</label> <input type="text" id="alarm-message"></div></div></div></div>';
}
return __p;
};
